<template>
  <div style="margin-top: 46px">

    <div class="content">
      <div class="chapterList">
        <div class="classTitle">
          {{ courseName }}
        </div>

        <div class="zjBox" v-for="(item, index) in chapterList" :key="item.cwId" @click="goPlayer(item)">
        <div class="zjIndex">
          <div class="bq">第{{ index + 1 }}节</div>
          <div class="wcd">完成度：{{ item.jinDu }}%</div>
        </div>
        <div class="chName">
          {{ item.cwName }}
        </div>

          <div class="xsOrBtn">
            <div class="xs"></div>
            <div class="btn" >播放</div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toStudyMain } from '@/api/myClass';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      chapterList: [],
      courseName: '',
      course: '',
      type:1,//2是职业培训课程
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goPlayer(item) {
      if (this.$route.query.type == 2) {
        this.$router.push({
          path: '/zyPlayer',
          query: {
            courseId: item.courseId,
            classId: this.$route.query.classId,
            courseWareId: item.cwId,
            courseName: this.courseName,
            chapterId:item.chapterId
          }
        });
      } else {
        this.$router.push({
          path: '/player',
          query: {
            courseId: item.courseId,
            classId: this.$route.query.classId,
            courseWareId: item.cwId,
            courseName: this.courseName,
            chapterId:item.chapterId
          }
        });
      }
    },
    gettToStudyMain() {
      toStudyMain({ courseId: this.$route.query.courseId,classId:this.$route.query.classId }).then(res => {
        this.chapterList = res.data.data.courseChapterList.rows;
        console.log(this.chapterList);
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.gettToStudyMain();
    this.courseName = this.$route.query.name
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.tips {
  width: 100%;
  height: 38px;
  background: rgba(250, 148, 89, 0.1);
  text-align: center;
  line-height: 38px;
  color: #fa9459;
  font-size: 13px;
}
.content {
  padding: 10px 15px;
  .classTitle {
      width: 100%;
      padding-bottom: 12px;
      border-bottom: 1px solid #eeeeee;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      font-weight: 600;
      font-size: 15px;
    }
  .chapterList {
    width: 100%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    padding: 10px 15px 30px 15px;
    
    .chapterBox {
      margin-top: 16px;
      margin-bottom: 20px;
      align-items: center;
      background: #eee;
      padding: 10px;
      border-radius: 5px;
      .t {
        margin-left: 12px;
        .t1 {
          color: #000000;
          font-size: 15px;
          font-weight: 500;
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-bottom: 6px;
        }
      }
      .xxBtn {
        width: 74px;
        height: 32px;
        background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
        border-radius: 27px 27px 27px 27px;
        text-align: center;
        line-height: 32px;
        color: #fff;
        font-size: 13px;
      }
    }
  }
}
.zjBox {
    margin-bottom: 35px;
    .activeTitle {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .activeColor {
      color: #2a70f2 !important;
    }
    .activeBtn {
      background: #2a70f2 !important;
      color: #fff !important;
    }
    .zjIndex {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bq {
        width: 48px;
        height: 24px;
        background: #f6f8fa;
        border-radius: 4px 4px 4px 4px;
        color: #666666;
        font-size: 13px;
        text-align: center;
        line-height: 24px;
      }
      .wcd {
        color: #9d9d9d;
        font-size: 12px;
      }
    }
    .chName {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      margin: 10px 0 1px 0;
      font-weight: 500;
    }
    .xsOrBtn {
      display: flex;
      justify-content: space-between;
      .xs {
        margin-top: 8px;
        color: #999999;
        font-size: 13px;
      }
      .btn {
        margin-top: 4px;
        width: 74px;
        height: 32px;
        background: #f3f3f5;
        border-radius: 27px 27px 27px 27px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #2a70f2;
      }
    }
  }
</style>
